import { render, staticRenderFns } from "./PrimeVideoUploader.vue?vue&type=template&id=7c595d48&scoped=true"
import script from "./PrimeVideoUploader.vue?vue&type=script&lang=js"
export * from "./PrimeVideoUploader.vue?vue&type=script&lang=js"
import style0 from "./PrimeVideoUploader.vue?vue&type=style&index=0&id=7c595d48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c595d48",
  null
  
)

export default component.exports